import React from "react";
import { FaRegHandshake } from "react-icons/fa";
import { GrCertificate } from "react-icons/gr";

import "./articleCard.scss";

const ArticleCard: React.FC = (): JSX.Element => {
	return (
		<div className="article-card-main-container" id="article-card-main-container-component">
			<div className="left-half-section">
				<h3 className="heading-text">
					Employee Benefits Structured to Support Employees&apos; Health, Wellness, and Preparedness
				</h3>
				<span>
					Health benefits and insurance coverages can bring peace of mind to employees and their families who
					would like to be prepared for life&apos;s unexpected events, such as injuries or illnesses.
				</span>
			</div>
			<div className="right-half-section">
				<div className="feature-container">
					<div className="icon-container">
						<GrCertificate />
					</div>
					<div className="textual-container">
						<h3>Certified</h3>
						<span>
							Ensuring reliable coverage with certified expertise for peace of mind during enrollment
							changes
						</span>
					</div>
				</div>
				<div className="feature-container">
					<div className="icon-container">
						<FaRegHandshake />
					</div>
					<div className="textual-container">
						<h3>Trusted</h3>
						<span>
							Count on us for enrollment security with a trusted track record in safeguarding individuals
							and their personal information.
						</span>
					</div>
				</div>
				<div className="feature-container">
					<div className="icon-container">
						<FaRegHandshake />
					</div>
					<div className="textual-container">
						<h3>Expert Agents</h3>
						<span>
							Benefits and Insurance seem to have a language of their own. Let our expert agents help you
							to confidently navigate through the enrollment process so that you are sure to elect the
							benefits that fit your needs and your budget.
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ArticleCard;
